export function getCapabilities(
  host: string,
  identifier: string,
  layers: string[]
) {
  const layerQuery = layers.join(',');
  return fetch(
    `${host}/ktproxy/capproxy/v1/getcap/${identifier}/${layerQuery}`
  );
}
